import { ReactNode } from "react";
import Grid from "@mui/material/Grid";

function ItemsGrid(props: {
  list: string[];
  render: (kind: string) => ReactNode;
}) {
  return (
    <Grid container spacing={4} justifyContent="center">
      {props.list.map((value, idx) => (
        <Grid key={idx}>{props.render(value)}</Grid>
      ))}
    </Grid>
  );
}

export default ItemsGrid;
